var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 162,
    viewBox: "0 0 183 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 71",
    x: 11,
    y: 4,
    width: 168,
    height: 154,
    rx: 16,
    fill: "#C83333",
    stroke: "#C83333",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 71_2",
    x: 1,
    y: 1,
    width: 174,
    height: 156,
    rx: 19,
    fill: "white",
    stroke: "#C83333",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shield"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84.4995 26.0003C77.2372 33.1849 58.6616 40.4432 37 55.8388C37 55.8388 38.3522 107.86 84.4995 136.298V26.0003Z",
    fill: "#C7F6D6",
    stroke: "#4D626C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M84.5005 26C91.7574 33.1846 110.338 40.4429 132 55.8385C132 55.8385 130.648 107.86 84.5005 136.298V26Z",
    fill: "#14A06F",
    stroke: "#4D626C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M84.5003 30.4288C75.7387 36.8876 60.5543 43.0458 40.4847 57.3073C40.4847 57.3073 41.7388 105.507 84.5003 131.869C127.262 105.518 128.516 57.3073 128.516 57.3073C108.441 43.0515 93.3274 36.8876 84.5003 30.4288Z",
    fill: "#14A06F",
    stroke: "#4D626C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M121.013 52.1869C90.3933 61.8268 67.036 89.811 56.4152 104.571C63.7209 115.718 73.3126 125.042 84.4994 131.87C127.261 105.518 128.515 57.3074 128.515 57.3074C125.931 55.4777 123.43 53.7709 121.013 52.1869Z",
    fill: "#C7F6D6",
    stroke: "#4D626C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M101.173 79.0313H68.3449C67.6219 79.0313 66.9285 78.7326 66.4172 78.2009C65.906 77.6692 65.6188 76.948 65.6188 76.1961V60.1257C65.7035 54.9074 67.7561 49.9325 71.3343 46.2734C74.9125 42.6142 79.7297 40.5636 84.7478 40.5636C89.7659 40.5636 94.5832 42.6142 98.1613 46.2734C101.74 49.9325 103.792 54.9074 103.877 60.1257V76.1961C103.877 76.9441 103.593 77.6619 103.086 78.1929C102.58 78.724 101.892 79.0254 101.173 79.0313ZM71.0928 73.3608H98.4464V60.1257C98.375 56.4023 96.9026 52.8565 94.3455 50.2495C91.7884 47.6425 88.3504 46.1823 84.7696 46.1823C81.1889 46.1823 77.7509 47.6425 75.1937 50.2495C72.6366 52.8565 71.1643 56.4023 71.0928 60.1257V73.3608Z",
    fill: "#C7F6D6",
    stroke: "#4D626C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M105.381 71.2852H63.6169V107.991H105.381V71.2852Z",
    fill: "#C7F6D6",
    stroke: "#4D626C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M88.8404 86.5278C88.8403 85.6919 88.6273 84.8709 88.2229 84.1484C87.8185 83.426 87.2372 82.828 86.5383 82.4152C85.8394 82.0025 85.0477 81.7898 84.244 81.7989C83.4403 81.8079 82.6533 82.0384 81.9631 82.4667C81.2729 82.8951 80.7042 83.5061 80.3149 84.2375C79.9257 84.9688 79.7298 85.7944 79.7472 86.6302C79.7645 87.4659 79.9946 88.2819 80.4139 88.9951C80.8332 89.7082 81.4268 90.2931 82.1341 90.69L81.3708 99.0257H87.2156L86.4523 90.69C87.1751 90.2858 87.779 89.6852 88.1995 88.9522C88.6201 88.2192 88.8415 87.3814 88.8404 86.5278V86.5278Z",
    fill: "#4D626C",
    stroke: "#C7F6D6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.6a35468e55e49528f279c15c633d54c7.svg";
export { ForwardRef as ReactComponent };